export const accountInitialState = {};

export const mapsInitialState = {
	items: [],
	isLoading: false,
};

export const mapsReducer = (state = mapsInitialState, action) => {

	switch (action.type) {
		case 'MAPS_LOADING':
			return {
				...state,
				isLoading: true,
			};
		case 'MAPS_CACHE':
			return {
				...state,
				isLoading: false,
			};
		case 'MAPS_GET':
			console.log('MAPS_GET', action.payload);

			let filtered = action.payload.data.data.filter((item) => !!item?.src);
			
			filtered = filtered.map((item) => {
				return {
					...item,
					src: item.src + '?v=' + new Date().getTime(),
				};
			});

			const newState = {
				...state,
				isLoading: false,
				items: filtered,
			};
			return newState;
		default:
			return state;
	}
};
